import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50 p-4 md:p-6 animate-slide-up">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-700 flex-1">
          Web sitemizde deneyiminizi geliştirmek için çerezler kullanılmaktadır. KVKK kapsamında kişisel verileriniz işlenmektedir. Detaylı bilgi için{' '}
          <Link to="/kvkk" className="text-secondary font-semibold hover:underline cursor-pointer">
            KVKK
          </Link>{' '}
          ve{' '}
          <Link to="/cerez-politikasi" className="text-secondary font-semibold hover:underline cursor-pointer">
            Çerez Politikamızı
          </Link>{' '}
          inceleyebilirsiniz.
        </p>
        <button
          onClick={handleAccept}
          className="bg-primary text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-primary/90 transition-all whitespace-nowrap cursor-pointer"
        >
          Kabul Et
        </button>
      </div>
    </div>
  );
}